"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_1 = require("react");
const MedicalApi_1 = __importDefault(require("../../api/MedicalApi"));
const react_loader_1 = __importDefault(require("react-loader"));
const Defaults_1 = require("../../common/Defaults");
const hui_1 = require("@mit/hui");
const PeopleStore_1 = require("../../model/PeopleStore");
const CovidNav_1 = require("../../model/CovidNav");
const EligibleUpload = ({ hideModalCallback, show, onClose }) => {
    const [uploadSuccess, setUploadSuccess] = (0, react_1.useState)(undefined);
    const [errorMessage, setErrorMessage] = (0, react_1.useState)("");
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [uploadFile, setUploadFile] = (0, react_1.useState)({ name: "", file: null });
    const fileUploadedInput = (0, react_1.useRef)(null);
    React.useEffect(() => {
        setUploadSuccess(undefined);
        setErrorMessage("");
    }, [show]);
    const handleClose = () => {
        setUploadFile({ name: "", file: null });
        if (fileUploadedInput.current) {
            fileUploadedInput.current.value = "";
        }
        onClose();
    };
    const submitAndClose = () => __awaiter(void 0, void 0, void 0, function* () {
        if (uploadFile.name) {
            setIsLoading(true);
            let uploadResponse = yield MedicalApi_1.default.uploadFile(uploadFile);
            setIsLoading(false);
            if (!uploadResponse.error) {
                setUploadSuccess(true);
            }
            else {
                setUploadSuccess(false);
            }
        }
        else {
        }
    });
    const handleFileUpload = (data) => __awaiter(void 0, void 0, void 0, function* () {
        let csvContent = "MIT_ID,START_DATE\r\n";
        data.forEach((rowArray) => {
            let row = rowArray.join(",");
            csvContent += row + "\r\n";
        });
        var blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        let uploadResponse = yield MedicalApi_1.default.uploadVaccineEligibleResults("upload.csv", blob);
        setIsLoading(false);
        if (!uploadResponse.error) {
            setUploadSuccess(true);
            reloadDataVaccine();
        }
        else {
            setUploadSuccess(false);
            setErrorMessage(uploadResponse.errorMessage.join(", "));
        }
    });
    const reloadDataVaccine = () => __awaiter(void 0, void 0, void 0, function* () {
        CovidNav_1.covidNav.globalTableIsLoading = true;
        const vaccineDetailResponse = yield MedicalApi_1.default.fetchVaccineResults(CovidNav_1.covidNav.currentDateString);
        if (vaccineDetailResponse.error) {
            //todo: handle error
        }
        else {
            if (vaccineDetailResponse.items) {
                PeopleStore_1.peopleStore.setVaccineList(vaccineDetailResponse.items);
                CovidNav_1.covidNav.globalTableIsLoading = false;
            }
        }
    });
    const fieldData = {
        MIT_ID: { required: true, pattern: { value: /^\d{9,12}$/, message: "MIT ID format" } },
        START_DATE: { required: true, type: "calendar", pattern: { value: /^(\d{4})[\-](\d{2})[\-]\d{2}$/, message: "Date format" } },
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(hui_1.Drawer, { contentAriaLabel: `Upload vaccine eligible persons`, header: (0, jsx_runtime_1.jsx)(hui_1.Text, { content: "Upload vaccine eligible persons.", type: hui_1.TextType.Heading3, icon: "" }), type: hui_1.DrawerType.Right, themedColor: "medical", show: show, onClose: onClose, size: hui_1.DrawerSize.Medium, footer: [], contents: (0, jsx_runtime_1.jsxs)("div", Object.assign({ id: "vaccine-eligible-persons-upload-drawer" }, { children: [(0, jsx_runtime_1.jsx)(react_loader_1.default, Object.assign({ loaded: !isLoading, options: Object.assign(Object.assign({}, Defaults_1.mediumLoaderOptions), { color: "#000000" }) }, { children: (0, jsx_runtime_1.jsxs)(react_bootstrap_1.Row, { children: [(0, jsx_runtime_1.jsx)(hui_1.BulkUpload, { themedColor: "medical", drawerSize: hui_1.DrawerSize.Medium, autoSave: false, onImport: handleFileUpload, formFields: fieldData, showTemplate: true }), (0, jsx_runtime_1.jsxs)(react_bootstrap_1.Col, Object.assign({ xs: 12 }, { children: [uploadSuccess === false && (0, jsx_runtime_1.jsx)(hui_1.Alert, { type: "error", text: `${errorMessage}` }), uploadSuccess === true && (0, jsx_runtime_1.jsx)(hui_1.Alert, { type: "success", text: "The file has been uploaded successfully." })] }))] }) })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "text-center" }, { children: [uploadSuccess && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "p-3" }, { children: (0, jsx_runtime_1.jsx)(hui_1.Button, { type: hui_1.ButtonType.Primary | hui_1.ButtonType.Ghost, onClick: handleClose, state: isLoading ? hui_1.ButtonState.Disabled : hui_1.ButtonState.Enabled, text: "Done" }) }))), uploadSuccess !== true && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "p-3" }, { children: (0, jsx_runtime_1.jsx)(hui_1.Button, { type: hui_1.ButtonType.Primary | hui_1.ButtonType.Ghost, onClick: handleClose, state: isLoading ? hui_1.ButtonState.Disabled : hui_1.ButtonState.Enabled, text: "Cancel" }) })))] }))] })) }) }));
};
exports.default = EligibleUpload;
